module.exports = "/images/thumbs-up.svg?a9dfd46ea67d1a52a3ed9cdf03ccd088";